/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Telefonnumber1Inputs */

const de__field_telefonnumber1 = /** @type {(inputs: _Field_Telefonnumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonnummer`)
};

/**

* @param {_Field_Telefonnumber1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_telefonnumber1 = /** @type {((inputs?: _Field_Telefonnumber1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Telefonnumber1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_telefonnumber1(inputs)
});
export { _field_telefonnumber1 as "_field_telefonNumber" }